import {clsx, styled} from 'external/material'
import useTranslations from 'hooks/translations'
import useStudentContext from 'hooks/student'
import { centerVertically } from 'utils/style'
import DashboardActivityItem from './DashboardActivityItem'
import GroupFilter from 'components/GroupFilter'

import EventCategoryFilter from 'components/EventCategoryFilter'

const StyledDashboardActivity = styled('div')(dashboardActivityStyles)

export default function DashboardActivity(props) {
    const {translate} = useTranslations()
    const {groups, recentActivity} = useStudentContext()

    return(
        <StyledDashboardActivity {...props}>
            <div className='recent-activity-container'>
                <div className='recent-activity-title'>
                    <div className={clsx('filter', 'group')}>
                        <GroupFilter preserveQuery />
                    </div>
                    <div className={clsx('filter', 'category')}>
                        <EventCategoryFilter preserveQuery />
                    </div>
                </div>
                <div className='recent-activity-content'>
                    <div className={clsx('activity', {empty: recentActivity.length == 0})}>
                        {recentActivity.length == 0 && <div className="no-recent-activity-label">{translate('no-recent-activity-found')}</div>}
                        {recentActivity.map((activity, index) => (<DashboardActivityItem key={index} activity={activity} group={groups.find(g => g.id == activity.clique)} />))}
                    </div>
                </div>
            </div>
        </StyledDashboardActivity>
    )
}

function dashboardActivityStyles(){
    return {
        display: 'flex',
        overflowY: 'hidden',
        '& .recent-activity-container': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden',
            paddingBottom: 10,
        },
        '& .recent-activity-title': {
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: 20,
            marginBottom: 10,
            fontSize: '16pt',
            fontWeight: 500,
            flexShrink:0,
            color: '#434a5d',
            "& > label": {
                ...centerVertically,
                flexGrow: 1,
            },
            "& > .filter": {
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0,
                marginTop: 15,
                "& .MuiSelect-select.MuiInputBase-input.MuiInputBase-inputAdornedEnd": {
                    fontSize: '10.5pt'
                },
                "&.group": {
                    width: 165,
                },
                "&.category": {
                    width: 165,
                    marginLeft: 15,
                    marginRight: 2,
                }
            },
        },
        '& .recent-activity-content': {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            paddingRight: 20,
            overflowY: 'auto',
            '& .activity.empty': {
                marginTop: 100,
                fontSize: '2rem',
                color: '#81838a',
                flexGrow: 1,
                textAlign: 'center',
            },
        }
    }
}
